// @ts-nocheck

(() => {
  const processSubmitForm = {
    emailGate: document.querySelector(".fm-o-email-gate"),
    init() {
      if (typeof window.$$epiforms === 'undefined') {
        return;
      }

      this.freezeAndBlurDocument();
      this.createOverlayButton();
      window.$$epiforms(".fm-o-email-gate .EPiServerForms").on('formsSubmitted', this.handleFormSuccess.bind(this));
      window.$$epiforms(".fm-o-email-gate .EPiServerForms").on('formsSubmittedError', this.handleFormSubmittedError.bind(this));
      window.$$epiforms(".fm-o-email-gate .EPiServerForms").on('elementValidated', this.handleAfterValidate.bind(this));
    },
    freezeAndBlurDocument() {
      if (!this.emailGate) {
        return;
      }

      document.body.classList.add('no-scroll');
      document.body.classList.add('blur');

      if (this.emailGate.className.includes('popup')) {
        document.querySelector('main')?.classList.add('blur');
      }
    },
    handleFormSuccess(event) {
      document.body.style.overflow = '';
      document.body.classList.remove('blur');
      document.body.classList.remove('no-scroll');
      document.querySelector('main')?.classList.remove('blur');

      this.removeLoading();
      this.hideEmailGate();

      // set cookie for BE process
      this.setCookie(event.formData);
    },
    handleFormSubmittedError() {
      this.scrollToTop();
      this.removeLoading();
    },
    handleAfterValidate(event, param1, param2) {
      if (!event.isValid) {
        this.scrollToTop();
        this.removeLoading();
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    addLoading() {
      if (!this.emailGate) {
        return;
      }

      this.emailGate.classList.add('loading');
    },
    removeLoading() {
      if (!this.emailGate) {
        return;
      }

      this.emailGate.classList.remove('loading');
    },
    createOverlayButton() {
      const button = document.querySelector(".fm-o-email-gate .EPiServerForms button[type='submit']");

      if (!button) {
        return;
      }

      const buttonOverlay = document.createElement<HTMLSpanElement>('span');
      buttonOverlay.classList.add('button-overlay');
      buttonOverlay.ariaHidden = 'true';
      buttonOverlay.addEventListener('click', (event: Event) => {
        event.stopPropagation();
        event.preventDefault();
        this.addLoading();

        setTimeout(this.triggerButtonClick.bind(this), 500);
      });

      button.append(buttonOverlay);
    },
    triggerButtonClick() {
      const button = document.querySelector(".fm-o-email-gate .EPiServerForms button[type='submit']");

      if (!button) {
        return;
      }

      button.dispatchEvent(new Event('click'));
    },
    hideEmailGate() {
      if (!this.emailGate) {
        return;
      }

      this.emailGate.classList.add('hidden');
    },
    setCookie(formData: FormData) {
      const inputName = this.emailGate?.querySelector('input[type="text"], input[type="email"]')?.name;
      const inputValue = inputName && formData && formData.get(inputName);

      document.cookie = `firstmile_email_gate=${inputValue}`;
    }
  };

  processSubmitForm.init();
})();